<template>
  <div class="b1">
    <div class="flex_between_nowrap">
      <div class="flex_between_nowrap">
        <span class="title_before side_title">盘点审批</span>
      </div>
      <div>
        <el-button
          @click="$router.back()"
          type="text"
          class="addColor"
          style="font-size:16px;margin-right:20px;margin-top:20px"
          icon="iconfont icon-shangyibu"
          >返回</el-button
        >
      </div>
    </div>
    <div style="padding:0px 24px;margin-top:20px">
      <x-table
      max-height='500'
        url="/pc/pdexamine/asset_details"
        ref="xTable"
        :params="{ id: $route.query.id }"
      >
        <el-table-column
          :label="item.label"
          :prop="item.model"
          show-overflow-tooltip
          v-for="item in columnArr"
          :key="item.model"
        >
          <template slot-scope="scope">
            <el-tag
              :style="checkResultFulter(scope.row[item.model], false)"
              v-if="item.model == 'checkResult'"
              >{{ checkResultFulter(scope.row[item.model], true) }}</el-tag
            >
            <el-tag
              :style="assetStatusFulter(scope.row[item.model], false)"
              v-else-if="item.model == 'assetStatus'"
              >{{ assetStatusFulter(scope.row[item.model], true) }}</el-tag
            >
            <span v-else-if="item.model == 'checkStatus'">{{
              scope.row[item.model] ? "是" : "否"
            }}</span>

            <span v-else>{{ scope.row[item.model] }}</span>
          </template>
        </el-table-column>
      </x-table>

      <div class="flex_between_nowrap" style="margin-top:40px;padding-bottom:40px">
        <div class="flex_start" style="flex:1">
          <label style="width:100px;text-align:left">审批备注</label>
          <el-input
            style="flex:1"
            v-model="approveRemark"
            placeholder="审批备注"
            clearable
            type="textarea"
            autosize
          ></el-input>
        </div>

        <div class="flex_end" style="margin-left:120px;">
          <el-button
            class="dialog_close"
            size="small"
            type="danger"
            @click="examine(false, $route.query.id, approveRemark)"
            >驳 回</el-button
          >
          <el-button
            class="dialog_submit"
            size="small"
            style="width:100px"
            type="submit"
            @click="examine(true, $route.query.id, approveRemark)"
            >同 意</el-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      pdresult: [
        {
          label: "未盘",
          model: "not",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "盘亏",
          model: "little",
          style: "color:#fa675c;background:#ffd0cc;",
        },
        {
          label: "正常",
          model: "normal",
          style: "color:#42b983;background:#f0f9eb;",
        },
        {
          label: "盘盈",
          model: "more",
          style: "color:#ffa200;background:#ffefd8;",
        },
      ],
      statusArr: [
        {
          label: "未盘",
          model: "not",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "盘点中",
          model: "await",
          style: "color:#436bff;background:#d8e6ff;",
        },
        {
          label: "等待审核",
          model: "examine",
          style: "color:#ffa200;background:#ffefd8;",
        },
        {
          label: "完成",
          model: "end",
          style: "color:#42b983;background:#f0f9eb;",
        },
      ],
      columnArr: [
        {
          label: "盘点结果",
          model: "checkResult",
        },
        {
          label: "是否盘到",
          model: "checkStatus",
        },

        {
          label: "状态",
          model: "assetStatus",
        },
        {
          label: "资产编码",
          model: "assetCode",
        },
        {
          label: "资产名称",
          model: "assetName",
        },
        {
          label: "使用人",
          model: "usePersonName",
        },
        {
          label: "资产分类",
          model: "assetClassifyName",
        },

        {
          label: "所属部门",
          model: "deptName",
        },
        {
          label: "使用部门",
          model: "useDeptName",
        },
        {
          label: "管理人员",
          model: "assetAdminName",
        },
        {
          label: "所在区域",
          model: "areaName",
        },
        {
          label: "资产来源",
          model: "sourceName",
        },
        {
          label: "存放地点",
          model: "depositArea",
        },
        {
          label: "规格型号",
          model: "spec",
        },
        {
          label: "计量单位",
          model: "unit",
        },
      ],

      approveRemark: "",
    };
  },
  mounted() {},
  methods: {
    assetStatusFulter(data, flag) {
      let str = "";
      if (flag) {
        switch (data) {
          case "idle":
            str = "闲置";

            break;

          case "use":
            str = "在用";

            break;
          case "borrow":
            str = "借用";

            break;
          case "repair":
            str = "维修中";

            break;
          case "dispose":
            str = "处置";

            break;
          case "examine":
            str = "审批中";

            break;
        }
      } else {
        switch (data) {
          case "use":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "borrow":
            str = "color:#436bff;background:#d8e6ff;";

            break;
          case "examine":
            str = "color:#436bff;background:#d8e6ff;";

            break;

          case "idle":
            str = "color:#42b983;background:#f0f9eb;";

            break;
          case "dispose":
            str = "color:#ffa200;background:#ffefd8;";
            break;
          case "repair":
            str = "color:#ffa200;background:#ffefd8;";
            break;
        }
      }
      return str;
    },
    checkResultFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.pdresult.length; i++) {
        if (this.pdresult[i].model == data) {
          a = flag ? this.pdresult[i].label : this.pdresult[i].style;
          break;
        }
      }
      return a;
    },
    checkStatusFulter(data, flag) {
      let a = "";
      for (let i = 0; i < this.statusArr.length; i++) {
        if (this.statusArr[i].model == data) {
          a = flag ? this.statusArr[i].label : this.statusArr[i].style;
          break;
        }
      }
      return a;
    },
    examine(pass, id, remark) {
      this.$requestAxios(
        {
          url: "/pc/pdexamine/examine",
          data: { id, pass, remark },
        },
        (data) => {
          this.$success();
         this.$router.back()
          this.callBack();
        }
      );
    },
  },
};
</script>
<style scoped></style>
